module.exports = "https://cdn.redage.net/src/views/player/help/images/post2.jpg";